const DetailsSidebarCardSkeleton = () => {
    return(
        <div className="flex flex-col gap-4">

            {/* PIC Details */}
            <div className="flex flex-col gap-4 border border-[#64748B] rounded-lg p-4 bg-white animate-pulse">
                <h1 className="font-bold text-xl">PIC Details</h1>

                <div className="flex flex-col gap-2">

                {/* Name */}
                <div className="py-2 flex justify-between items-center">
                    <div className="flex flex-col gap-1">
                    <div className="w-24 h-4 bg-gray-300 rounded"></div>
                    <div className="w-40 h-4 bg-gray-200 rounded"></div>
                    </div>
                    <div className="w-6 h-6 bg-gray-200 rounded"></div>
                </div>

                {/* Phone */}
                <div className="py-2 flex justify-between items-center">
                    <div className="flex flex-col gap-1">
                    <div className="w-32 h-4 bg-gray-300 rounded"></div>
                    <div className="w-28 h-4 bg-gray-200 rounded"></div>
                    </div>
                    <div className="w-6 h-6 bg-gray-200 rounded"></div>
                </div>

                {/* Email */}
                <div className="py-2 flex justify-between items-center">
                    <div className="flex flex-col gap-1">
                    <div className="w-28 h-4 bg-gray-300 rounded"></div>
                    <div className="w-52 h-4 bg-gray-200 rounded"></div>
                    </div>
                    <div className="w-6 h-6 bg-gray-200 rounded"></div>
                </div>

                </div>
            </div>

            {/* Upcoming Reminder */}
            <div className="flex flex-col gap-4 border border-[#64748B] rounded-lg p-4 bg-white animate-pulse">

                <div className="flex flex-row justify-between items-center">
                <div className="w-40 h-5 bg-gray-300 rounded"></div>
                <div className="w-28 h-5 bg-gray-200 rounded-full"></div>
                </div>

                <div className="p-2 flex flex-col rounded-lg bg-[#F2F4F7] border-[#F2F4F7] gap-2">
                <div className="w-48 h-4 bg-gray-300 rounded"></div>
                <div className="w-full h-4 bg-gray-200 rounded"></div>
                <div className="w-5/6 h-4 bg-gray-200 rounded"></div>
                </div>

            </div>

        </div>
    )
}

export {DetailsSidebarCardSkeleton}